import { Routes } from '@angular/router';

export const MOBILE_ABOUT_INFO_ROUTES: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/project-menu/project-menu.component').then(c => c.AboutProjectMenuComponent),
  },
  {
    path: 'info',
    loadComponent: () =>
      import('./pages/project-info/project-info.component').then(c => c.AboutProjectInfoComponent),
  },
  {
    path: 'offer',
    loadComponent: () =>
      import('./pages/project-offer/project-offer.component').then(
        c => c.AboutProjectOfferComponent,
      ),
  },
  {
    path: 'legal-acts',
    loadComponent: () =>
      import('./pages/legal-acts/legal-acts.component').then(c => c.AboutProjectLegalActsComponent),
  },
  {
    path: 'press',
    loadComponent: () =>
      import('./pages/project-press/project-press.component').then(
        c => c.AboutProjectPressComponent,
      ),
  },
  {
    path: 'contacts',
    loadComponent: () =>
      import('./pages/project-contacts/project-contacts.component').then(
        c => c.AboutProjectContactsComponent,
      ),
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('./pages/project-delete-account/project-delete-account.component').then(
        c => c.AboutProjectDeleteAccountComponent,
      ),
  },
];
